import Organization from 'infrastructure/Organization';

export const handleBeforeUnload = ({ assignment_uuid, scenario_uuid, session_uuid }) => {
  const org_id = Organization.getSelectedOrg()?.id;
  try {
    if (session_uuid) {
      const url = `/orgs/${org_id}/realplays/assignments/${assignment_uuid}/scenarios/${scenario_uuid}/sessions/${session_uuid}`;
      const data = { status: 'CANCELED' };
      navigator.sendBeacon(url, JSON.stringify(data));
    }
  } catch (error) {
    console.error('Error send beacon:', error);
  }
};
